module.exports = __webpack_public_path__ + "static/media/cg.e876c94a.jpg";